/**
 * Semantic section identifiers for the public API
 */
export const Section = {
  RESOURCES: 'resources',
  METRICS: 'metrics',
  OWNERSHIP: 'ownership',
  LIFECYCLE: 'lifecycle',
  PROVISIONING: 'provisioning',
  GREEN_ENERGY: 'greenEnergy',
  PRIVACY: 'privacy',
  SHOWBACK: 'showback',
  AUDIT_EVENTS: 'auditEvents',
  DEPENDENCY: 'dependency',
  IAM: 'iam',
  SECURITY: 'security',
} as const;

export type SectionKey = (typeof Section)[keyof typeof Section];

/**
 * Configuration for what sections/features to display for an application
 */
export interface ApplicationDisplayConfig {
  // Section visibility
  showResources: boolean;
  showMetrics: boolean;
  showOwnership: boolean;
  showLifecycle: boolean;
  showProvisioning: boolean;
  showGreenEnergy: boolean;
  showPrivacy: boolean;
  showShowback: boolean;
  showAuditEvents: boolean;
  showDependency: boolean;
  showIAM: boolean;
  showSecurity: boolean;

  // Resource-specific visibility
  allowedResourceTypes: string[];

  // Action availability
  canEdit: boolean;
  canDelete: boolean;
  canProvision: boolean;
  canRetire: boolean;
  canManageTags: boolean;

  // UI customization
  isExperimental: boolean;
  statusBadgeVariant: 'success' | 'warning' | 'error' | 'info' | 'default';
  displayMode: 'full' | 'compact' | 'readonly';
}

/**
 * Internal mapping from semantic section identifiers to config property names
 */
export const SECTION_TO_CONFIG_KEY: Record<
  SectionKey,
  keyof ApplicationDisplayConfig
> = {
  resources: 'showResources',
  metrics: 'showMetrics',
  ownership: 'showOwnership',
  lifecycle: 'showLifecycle',
  provisioning: 'showProvisioning',
  greenEnergy: 'showGreenEnergy',
  privacy: 'showPrivacy',
  showback: 'showShowback',
  auditEvents: 'showAuditEvents',
  dependency: 'showDependency',
  iam: 'showIAM',
  security: 'showSecurity',
};
